import { css } from '@emotion/react';
import type * as React from 'react';

/**
 * One column, as wide as a reading column: the screen scrolls on its own so the identity header and
 * the actions stay in the flow of the page.
 */
const screenStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	width: 100%;
	max-width: 51.25rem;
	min-height: 0;
	overflow-y: auto;
`;

type Props = {
	readonly children: React.ReactNode;
};

/** The reading column that stacks a dossier's header and sections. */
const SubjectReadingColumn: React.FC<Props> = ({ children }) => {
	return <div css={screenStyle}>{children}</div>;
};

export default SubjectReadingColumn;
